<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="70%"
    top="5vh"
    class="contacts-modal"
    @open="onOpen"
    @close="onClose"
  >
    <el-row slot="title" type="flex" justify="space-between" align="middle">
      <h2>ОБЗВОН, СПИСОК КОНТАКТОВ</h2>
      <b>
        <el-button type="text" class="close-btn" @click="toCall">
          <b>звонить</b>
        </el-button>
      </b>
    </el-row>
    <el-table v-loading="loading" :data="list" style="width: 100%">
      <el-table-column label="Телефон" prop="phone" />
      <el-table-column label="ФИО" prop="fio" />
      <el-table-column align="right">
        <template slot="header" slot-scope="scope">
          <el-input
            v-model="search"
            size="mini"
            placeholder="Введите для поиска"
            :disabled="loading"
            @blur="fetchList"
            @keyup.enter.native="fetchList"
          />
        </template>
        <template slot-scope="scope">
          <el-button
            type="text"
            class="del"
            :loading="loadingDelCT"
            @click="onDelete(String(scope.row.id))"
          >
            <b>x</b>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" align="middle" class="btn-block">
      <el-col :span="12">
        <pagination-custom :data="pagination" @changed="changePage" />
      </el-col>
      <el-col :span="12" class="ta-r add-btn">
        <el-button
          type="primary"
          :loading="loading || loadingDelCT"
          @click="onAdd"
        >
          Добавить контакты
        </el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PaginationCustom from '@/components/Tables/PaginationCustom'

export default {
  name: 'ContactsModal',
  components: { PaginationCustom },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      search: '',
      page: 1,
    }
  },
  computed: {
    ...mapGetters({
      getList: 'callCenter/getList',
      getPagination: 'callCenter/getPagination',
      getLoading: 'callCenter/getLoading',
    }),
    list() {
      return this.getList('contacts')
    },
    loading() {
      return this.getLoading('Cont')
    },
    loadingDelCT() {
      return this.getLoading('DelCT')
    },
    pagination() {
      return this.getPagination('Cont')
    },
  },
  methods: {
    ...mapActions({
      fetchContacts: 'callCenter/fetchContacts',
      deleteContact: 'callCenter/deleteContFromTask',
    }),
    fetchList() {
      const { search, page, id: task_id } = this

      this.fetchContacts({ search, page, task_id })
    },
    changePage(page = 1) {
      this.page = page
      this.fetchList()
    },
    onOpen() {
      this.fetchList()
    },
    onAdd() {
      this.onClose()
      this.$emit('set', 'addContactModal', this.id)
    },
    toCall() {
      this.onClose()
      this.$emit('set', 'callModal', this.id)
    },
    onDelete(contact_ids) {
      const { search, page, id: task_id } = this
      const settings = { search, page, task_id }

      this.deleteContact({ settings, contact_ids })
    },
    onClose() {
      this.$emit('set', 'contactsModal')
    },
  },
}
</script>

<style lang="sass">
.contacts-modal
  h2
    margin: 30px
    font-weight: bold
    font-size: 18px
    line-height: 17px
  .close-btn
    margin-right: 30px
    text-decoration: underline
  .el-textarea__inner, .el-button
    font-size: 16px
    font-family: Rubik, sans-serif
  .el-dialog__body
    padding: 0 50px 50px
    p
      font-size: 18px
      line-height: 17px
      color: #000
    .btn-block
      margin-top: 100px
      .add-btn button
        width: 300px
        height: 47px
        font-weight: normal
    .del
      color: #FF0505
      font-size: 20px
      cursor: pointer
</style>
